export default {
    intro_header: "Which beer to pair with the dish?",
    intro_content_1: "Do your guests wish to dine with Książęce?",
    intro_content_2: "Use the foodpairing generator to find out which beer goes best with the chosen dish! Create a one-of-a-kind menu and serve combinations that will delight everyone!",

    no_results: "No search results.",
    no_results_content: "Send us a dish suggestion. We'd like to add it to our database.",
    no_results_cta: "Suggest a dish",

    search: "Search for a dish",

    alcohol: "Alcohol",
    alcohol_suffix: "vol.",
    bitterness: "Bitterness",
    bitterness_suffix: "IBU",

    and: "and",
    change: "Change",

    beer_dish: "Best enhance to your dish:",
    beer_match: "Match the beer to another dish",

    popup_optional: "Add optionally:",
    popup_no_additive: "Add-on (none)",
    popup_not_found: "Not found",
    popup_sauce: "sauce",
    popup_sauce_none: "sauce (none)",
    popup_cta: "Match the beer",

    form_required: "Mandatory field",
    form_wrong_email: "Invalid e-mail address",
    form_title: "Suggest a dish",
    form_name: "Enter the dish's name",
    form_description: "Dish description (optional)",
    form_email: "E-mail address",
    form_restaurant: "The place's name (optional)",
    form_submit: "Submit",
    form_success: "Thank you for your suggestion",
    form_add_more: "Add another",

    select_category: "Select category"
}